import { JSX, ReactNode, useState } from 'react'

import { Drawer, Portal, Button, CloseButton } from '@chakra-ui/react'
// eslint-disable-next-line no-duplicate-imports
import { DrawerRootProps, DrawerOpenChangeDetails } from '@chakra-ui/react'


import * as datective from '@/lib/detective.js'




type Options = {
	title?: string

	size? : DrawerRootProps['size']
	focus?: boolean

	footer?: ReactNode

}


let on_close_ = () : void =>
{
	// 

}

let on_open_ = (body: ReactNode, options?: Options) : void =>
{
	// 

}


export function close (): void
{
	on_close_()

}

export function open
(body: ReactNode, options?: Options): void
{
	on_open_(body, options)

}

export function confirm
(
	body: ReactNode,
	options?: Omit<Options, 'footer'>
				& {
					confirm?(...args: any[]): unknown
					cancel?(...args: any[]): unknown

				},

)
:	void
{
	let on_confirm = (): void =>
	{
		options?.confirm?.()

	}

	let on_cancel = (): void =>
	{
		options?.cancel?.()

	}

	on_open_(
		body,

		{
			...options,

			footer: (
				<>
					<Button variant="outline" onClick={on_cancel}>
						<span>取消</span>

					</Button>

					<Button colorPalette="blue" onClick={on_confirm}>
						<span>确认</span>

					</Button>

				</>

			),

		},

	)

}


export default function (): JSX.Element
{
	let [size, update_size] = useState<Options['size']>()
	let [focus, update_focus] = useState<Options['focus']>(false)

	let [body, update_body] = useState<ReactNode>(<></>)

	let [title, update_title] = useState<ReactNode>(<></>)
	let [footer, update_footer] = useState<ReactNode>(<></>)

	let [state, update_state] = useState(false)

	let on_open_change = (details: DrawerOpenChangeDetails): void =>
	{
		update_state(details.open)

	}

	on_open_ = (body_: ReactNode, options?: Options): void =>
	{
		update_size(options?.size)
		update_focus(options?.focus ?? false)

		update_body(body_)

		if (datective.is_required_string(options?.title) )
		{
			update_title(
				<Drawer.Header>
					<Drawer.Title>{options.title}</Drawer.Title>

				</Drawer.Header>,

			)

		}


		if (datective.is_exist(options?.footer) )
		{
			update_footer(
				<Drawer.Footer>{options.footer}</Drawer.Footer>,

			)

		}

		update_state(true)

	}

	on_close_ = (): void =>
	{
		update_state(false)

	}

	return (
		<Drawer.Root open={state} size={size} trapFocus={focus} onOpenChange={on_open_change}>
			<Portal>
				<Drawer.Backdrop />

				<Drawer.Positioner>
					<Drawer.Content>
						{title}

						<Drawer.Body overflowX="hidden" scrollbarWidth="thin">{body}</Drawer.Body>

						{footer}

						<Drawer.CloseTrigger asChild>
							<CloseButton size="sm" />

						</Drawer.CloseTrigger>

					</Drawer.Content>

				</Drawer.Positioner>

			</Portal>

		</Drawer.Root>

	)

}
